import {IEnvironment} from '../app/application/environment.provider'

export const environment: IEnvironment = {
  production: true,
  authServiceUrl: 'https://spb-common-api.internal.sparbankensyd.se/service',
  dataServiceUrl: 'https://ov.internal.sparbankensyd.se/api',
  villkorHost: 'villkor.lana.sparbankensyd.se',
  profitUrl: 'https://lk.internal.sparbankensyd.se',
  domain: 'ov.internal.sparbankensyd.se',
  testMode: false
}
